<template>
  <div>
    <!--面包屑-->
    <breadcrumb-link></breadcrumb-link>
    <!--内容区域-->
    <div>
      <!--查询条件-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" ref="filters">
          <el-form-item
            label="Pipeline名称"
            prop="pipelineName"
          >
            <el-input v-model="pipelineName" placeholder="Pipeline名称"></el-input>
          </el-form-item>
          <el-form-item label="是否配置FileSink" prop="hasFileSink" label-width="120px">
            <el-select v-model="hasFileSink" placeholder="请选择">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <!--查询、重置、新增-->
      <ws-btn-area
        :config="btnAreaConfig"
      ></ws-btn-area>
      <!--table-->
      <ws-table
        :config="tableConfig"
        :tableData="tableData"
        :pageConfig="page"
        :header-cell-style="{background:'#f2f2f2'}"
      ></ws-table>
      <el-dialog
        :title="tableData[index] && tableData[index].pipelineName"
        :visible.sync="submitterDialog"
        width="50%"
        custom-class="executor-dialog"
      >
        <div class="content">
          <div class="content-item">
            <div class="i-item-line">
              <div class="line-item">
                <div class="line-item-left">Route名称：</div>
                <div class="line-item-right">{{submitterDetail.submitName}}</div>
              </div>
              <div class="line-item">
                <div class="line-item-left">状态：</div>
                <div class="line-item-right">{{submitterDetail.state}}</div>
              </div>
            </div>
            <div class="i-item-line">
              <div class="line-item">
                <div class="line-item-left">是否正在提交：</div>
                <div class="line-item-right">{{submitterDetail.isSubmitting ? '是' : '否'}}</div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="submitterDialog = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :title="tableData[index] && tableData[index].pipelineName"
        :visible.sync="executorDialog"
        width="750px">
        <div class="content">
          <div class="content-item" v-for="(item, index) in executorDetail.records" :key="index">
            <div class="i-item-line">
              <div class="line-item">
                <div class="line-item-left">Route名称：</div>
                <div class="line-item-right">{{item.routeName}}</div>
              </div>
              <div class="line-item">
                <div class="line-item-left">状态：</div>
                <div class="line-item-right">{{item.currentState}}</div>
              </div>
            </div>
            <div class="i-item-line">
              <div class="line-item">
                <div class="line-item-left">运行时长：</div>
                <div class="line-item-right">
                  <div class="line-item-right-text">{{item.runTime}}</div>
                  <div class="line-item-right-icon">S</div>
                </div>
              </div>
              <div class="line-item">
                <div class="line-item-left">已处理批次：</div>
                <div class="line-item-right">{{item.batchNum}}</div>
              </div>
            </div>
            <div class="i-item-line">
              <div class="line-item">
                <div class="line-item-left">已处理条目数：</div>
                <div class="line-item-right">{{item.recordNum}}</div>
              </div>
            </div>
          </div>
          <el-col :span="24" style="margin-top:20px">
            <el-pagination
              background
              :current-page="routePage.pageNo"
              :page-size="routePage.pageSize"
              :total="routePage.total"
              :page-sizes="[10, 20, 30, 40, 50]"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="routePage.handleSizeChange"
              @current-change="routePage.handleCurrentChange"></el-pagination>
          </el-col>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="executorDialog = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import BreadcrumbLink from '../../../components/breadcrumbLink';
  import wsTable from '../../../components/wsTable'
  import wsBtnArea from '../../../components/wsBtnArea'
  import { setBtnAreaConfig, setTableConfig } from './config.js'

  import util from '@/utils/util';
  import {powerMixin} from '@/utils/mixin';
  import {
    getExecutorSubmitterList,
    getExecutorStatusByIp,
    getSubmitterStatusByIp,
    executorStartByIp,
    executorStopByIp,
    submitterStartByIp,
    submitterStopByIp
  } from '@/apis/pipelineService/pipelineControl';
  import {
    getPipelineList,
  } from '@/apis/pipelineService/pipelineConfig'
  export default {
    mixins: [powerMixin],
    components: {
      BreadcrumbLink,
      wsTable,wsBtnArea
    },
    data() {
      return {
        code: '', // 列表无数据默认值
        pipelineName: null,
        hasFileSink: null,
        createTime: null,
        searchOptions: {},
        btnAreaConfig: setBtnAreaConfig.call(this),
        tableConfig: setTableConfig.call(this),
        tableData: [],
        page: {
          pageNo: 1,
          pageSize: 10,
          total: 0,
          pageItem: [10],
          handleSizeChange: (size) => {
            this.page.pageSize = size
            this.getList();
          },
          handleCurrentChange: (page) => {
            this.page.pageNo = page
            this.getList();
          }
        },
        routePage: {
          pageNo: 1,
          pageSize: 10,
          total: 0,
          handleSizeChange: (size) => {
            this.routePage.pageSize = size
            this.getDetail(this.scope, this.type)
          },
          handleCurrentChange: (page) => {
            this.routePage.pageNo = page
            this.getDetail(this.scope, this.type)
          }
        },
        submitterDetail: {},
        executorDetail: {name:'这是一条测试数据'},
        submitterDialog: false,
        executorDialog: false,
        scope:null,
        type:null,
        index: null
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      //查询
      getListCX() {
        this.page.pageNo = 1
        this.searchOptions = {
          pipelineName: this.pipelineName,
          hasFileSink:this.hasFileSink
        };
        this.getList();
      },
      //重置筛选条件
      resetForm(formName) {
        this.pipelineName = null,
        this.createTime = null,
        this.searchOptions = {};
        this.page.pageNo = 1;
        this.getList();
      },
      async getDetail(scope, type) {
        this.index = scope.$index
        this.scope = scope
        this.type = type
        let obj = type == 'submitter' ? null : {
          current: this.routePage.pageNo,
          size: this.routePage.pageSize,
          }
        let params = {
          ip: type == 'submitter' ? scope.row.submitterIp : scope.row.ip,
          ...obj
        }
        try {
          let data = type == 'submitter' ? await getSubmitterStatusByIp(params) : await getExecutorStatusByIp(params)
          if(data.code == 0) {
            this[type + 'Detail'] = data.data
            this[type + 'Dialog'] = true
            if(type == 'executor') {
              this.routePage.total =  data.data.total
            }
          } else {
            this.$message.error(data.message)
          }
        }catch {}
      },
      // 开启暂停
      startOrStop (type, status, submitterIp) {
        let data, text = '是否确认' + (status == 1 ? '启动' : '停止') + '该' + type
        this.$confirm(text)
          .then( async () => {
            let params = {
              ip: submitterIp
            }
            if(status == 1) {
              data = type == 'Submitter' ? await submitterStartByIp(params) : await executorStartByIp(params)
            }else {
              data = type == 'Submitter' ? await submitterStopByIp(params) : await executorStopByIp(params)
            }
            if(data.code == 0) {
              this.$message.success(data.message)
              this.getList()
            }else if(data.code == 1){
              this.$message.warning(data.message)
              // this.getList()
            }else {
              this.$message.error(data.message)
            }
          })
          .catch((error) => {console.log(error)});
      },
      // 获取列表数据
      async getList() {
        let params = {
          ...this.searchOptions,
          current: this.page.pageNo, //当前页
          size: this.page.pageSize, //当前条数
        };
        try {
          const data = await getExecutorSubmitterList(params)
          if (data.code == 0 && data.data) {
            this.tableData = data.data.records
            this.page.total = data.data.total
          }else {
            this.$message.error(data.message);
          }
        } catch (error) {
          // this.$message.error(error);
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .content {
    max-height: 400px;
    overflow: scroll;
    .content-item {
      margin-top: 20px;
      border-bottom: 1px dashed #d7d7d7;
      .i-item-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .line-item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-bottom: 20px;
          .line-item-left {
            width: 100px;
            text-align: right;
          }
          .line-item-right {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 200px;
            padding: 10px 0;
            padding-left: 10px;
            background: #F5F7FA;
            border:1px solid #DCDFE6;
            border-radius: 3px;
            .line-item-right-text {

            }
            .line-item-right-icon {
              margin-right: 5px;
              color: #DCDFE6;
            }
          }
        }
      }
    }
  }
</style>
